// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('variant.certificates', {
    controller: 'SuppliersController as vm',
    parent: 'variant',
    url: '/certificates-reports',
    template:
      '<variant-compliance-coverage article-id="vm.variant.article.id" variant-id="vm.variant.id"></variant-compliance-coverage>',
    data: { pageTitle: 'Certificates & reports' },
  });
  $stateProvider.state('variant.suppliers', {
    controller: 'SuppliersController as vm',
    parent: 'variant',
    url: '/suppliers',
    templateUrl: 'main/article/variant/suppliers/suppliers.tpl.html',
    data: { pageTitle: 'Suppliers' },
  });
};

class SuppliersController {
  constructor($rootScope, variant, $state) {
    'ngInject';

    $rootScope.pageTitle = `${variant.article.itemCode || ''} - ${
      $state.current.data.pageTitle
    }`;

    this.variant = variant;
  }
}

angular
  .module('main.article.variant.suppliers', [])
  .config(config)
  .controller('SuppliersController', SuppliersController);
